export default {
    option: {
        value: 'article',
        label: 'Article',

        children: [
            {
                value: 'read',
                label: 'Has read',
                match: (patient) => Object.keys(patient.count_event).some((type) => type.startsWith('article:'))
            },
            {
                value: 'not-read',
                label: 'Has not read',
                match: (patient) => Object.keys(patient.count_event).every((type) => !type.startsWith('article:'))
            }
        ]
    }
}
